import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LogoutComponent } from './logout/logout.component';
import { LoginComponent } from './login/login.component';
import { LockedComponent } from './locked/locked.component';
import { AccountHoldComponent } from './account-hold/account-hold.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { UserInviteConsentComponent } from './user-invite-consent/user-invite-consent.component';
import { InvitePasswordComponent } from './invite-password/invite-password.component';
import { VerifyEmailComponent } from './verify-email/verify-email.component';
import { RegisterComponent } from './register/register.component';
import { ProvisionComponent } from './provision/provision.component';
import { SsoComponent } from './sso/sso.component';
import { EmailChangeVerifyComponent } from './email-change-verify/email-change-verify.component';
import { PaymentSuccessComponent } from '../payment-success/payment-success.component';
import { CancelSubscriptionComponent } from './cancel-subscription/cancel-subscription.component';

const routes: Routes = [
  {
    path: '', children: [
      { path: '', redirectTo: '/login', pathMatch: 'full' },
      { path: 'login', component: LoginComponent },
      { path: 'loginsync4.0', component: LoginComponent },
      { path: 'logout', component: LogoutComponent },
      { path: 'account-suspended', component: LockedComponent, data: { page: 'suspended' } },
      { path: 'account-closed', component: LockedComponent, data: { page: 'closed' } },
      { path: 'accounting-hold', component: AccountHoldComponent },
      { path: 'passwordreset/:cachekey', component: ResetPasswordComponent },
      { path: 'forgot-password', component: ForgotPasswordComponent},
      { path: 'setuserinviteconsent', component: UserInviteConsentComponent },
      { path: 'setinvitepassword', component: InvitePasswordComponent },
      { path: 'verifyemail', component: VerifyEmailComponent },
      { path: 'register', component: RegisterComponent },
      { path: 'provision', component: ProvisionComponent },
      { path: 'cancelsub', component: CancelSubscriptionComponent },
      { path: 'sso', component: SsoComponent },
      { path: 'emailchange', component: EmailChangeVerifyComponent },
      { path: 'verifychangedemail', redirectTo: 'emailchange' },
      { path: 'forgotpassword', redirectTo: 'forgot-password'},
      { path: 'passwordhint', redirectTo: 'forgot-password'},
      { path: 'success', component: PaymentSuccessComponent },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule { }
